module.exports = __webpack_public_path__ + "static/media/music-page-cover.36c5e625.jpg";